// @flow
import React, { useState, useCallback } from 'react';

import { navigate } from '../../lib/helpers';
import { vehicleTaxRateApi } from '../../lib/api';
import type { PowerPeriodTaxRate } from '../../lib/types';
import { type VehicleTaxRate } from '../../lib/types';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import { InnerForm } from './components';
import { getBreadCrumbsByUrlForEdit } from '../../lib/autoBreadcrumbs';

type PageProps = {
  id: number
};

const entryPointPath = '/admin/vehicle-tax-rate/';

export default (props: PageProps) => {
  const [data: VehicleTaxRate, setData] = useState({
    id: props.id
  });

  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, props.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await vehicleTaxRateApi.get(props.id));
  }, [props.id]);

  const validatePowerPeriodTaxRates = (
    powerPeriodTaxRates: PowerPeriodTaxRate[]
  ): PowerPeriodTaxRate[] => {
    return powerPeriodTaxRates
      .map(
        (row: PowerPeriodTaxRate, index: number, arr: PowerPeriodTaxRate[]) => {
          return (
            !!row.taxRate && {
              ...row,
              powerFrom: arr[index - 1]?.powerTo || 0
            }
          );
        }
      )
      .filter(row => !!row);
  };

  const onSubmit = async (payload: VehicleTaxRate) => {
    payload.powerPeriodTaxRates = validatePowerPeriodTaxRates(
      payload.powerPeriodTaxRates
    );

    let id = payload.id;
    if (id) {
      await vehicleTaxRateApi.update(payload);
    } else {
      let data = await vehicleTaxRateApi.add(payload);
      id = data.id;
    }
    await navigate(`${entryPointPath}${id}`);
  };

  const onCancel = async (payload: VehicleTaxRate) => {
    if (data.id) {
      await navigate(`${entryPointPath}${data.id}`);
    } else await navigate(`${entryPointPath}`, true);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Налоговые коэффициенты для ТС'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}
    >
      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>
  );
};
